var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-marquee-slider',{staticClass:"clients",attrs:{"id":"marquee-slider","space":200,"speed":20000,"width":100,"reverse":false,"data-aos":"fade-down"}},_vm._l((_vm.clients),function(client,clientIndex){return _c('img',{key:clientIndex,staticClass:"clients__item",attrs:{"loading":"lazy","src":_vm.requireAsset(client.logo),"alt":""}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }